﻿<script>
	import { getContext } from 'svelte';

    import { registerPageComplete, getTealiumID } from "../tealium";
    import { pageNumber, currentPage, pageList } from '../stores/pageStore';
	import model from "../stores/modelStore";
	import lookups from "../stores/lookupStore";
	import textStore from "../stores/textStore";
	import { isValid } from "../validation";

	import PageSection from "../components/PageSection.svelte";
	import Form from "../components/Form.svelte";
	import FormRow from "../components/FormRow.svelte";
	import FormColumn from "../components/FormColumn.svelte";
	import Checkbox from "../components/Checkbox.svelte";
	import Contact from "../components/Contact.svelte";
	import Select from "../components/Select.svelte";
	import NavigationButtons from "../components/NavigationButtons.svelte";

	export let disabled = false;

	const { displayError } = getContext("error-modal");
	let buttons = null;

	$model.WebAttrStr = getTealiumID();

	window.onbeforeunload = (event) => {
		event.returnValue = `Are you sure you want to leave?`;
	};

	const handleSameContactDetails = async () => {
		$model.Claimant.EmailAddress = $model.Contact.EmailAddress;
		$model.Claimant.PhoneNumber = $model.Contact.PhoneNumber;

        $model.ClaimantAddress.GooglePlaceJson = $model.ContactAddress.GooglePlaceJson;
        $model.ClaimantAddress.FormattedAddress = $model.ContactAddress.FormattedAddress;
        $model.ClaimantAddress.Premise = $model.ContactAddress.Premise;
        $model.ClaimantAddress.Subpremise = $model.ContactAddress.Subpremise;
        $model.ClaimantAddress.Street = $model.ContactAddress.Street;
        $model.ClaimantAddress.Suburb = $model.ContactAddress.Suburb;
        $model.ClaimantAddress.State = $model.ContactAddress.State;
        $model.ClaimantAddress.Postcode = $model.ContactAddress.Postcode;
        $model.ClaimantAddress.Country = $model.ContactAddress.Country;
        $model.ClaimantAddress.CountryCode = $model.ContactAddress.CountryCode;
        $model.ClaimantAddress.Lat = $model.ContactAddress.Lat;
        $model.ClaimantAddress.Lng = $model.ContactAddress.Lng;
        $model.ClaimantAddress.PlaceId = $model.ContactAddress.PlaceId;
        $model.ClaimantAddress.GoogleMapsUrl = $model.ContactAddress.GoogleMapsUrl;
	};
	
	const handleSubmit = async (e) => {
        //e.preventDefault();
		buttons.blockNext();
		if (isValid()) {
			registerPageComplete("Personal Details",
				$model.Contact.EmailAddress,
				$model.Contact.PhoneNumber,
				$model.ReferralSource);

			let response = await model.saveModelAsync();

			if (!response.success) {
				console.log(displayError)
				displayError(response);
			} else {
				buttons.next();
			}
		}
		buttons.unblock();
	}

	$: {
		textStore.switchText($model.ClaimantType, $model.Claimant.FirstName, $model.Claimant.Surname);
	}

	$pageNumber = ($currentPage ? $currentPage.pageIndex : 0);

</script>

<PageSection>

	<Form {disabled} id="personal-details" on:submit={handleSubmit}>

		<h1>Personal Information</h1>

		<Contact bind:title="{$model.Contact.Title}"
				 bind:firstName="{$model.Contact.FirstName}"
				 bind:middleName="{$model.Contact.MiddleName}"
				 bind:surname="{$model.Contact.Surname}"
				 bind:dateOfBirth="{$model.Contact.DateOfBirth}"
				 bind:emailAddress="{$model.Contact.EmailAddress}"
				 bind:phoneNumber="{$model.Contact.PhoneNumber}"
				 bind:address="{$model.ContactAddress}"
				 idPrefix="cont"
				 required {disabled}></Contact>

		<FormRow>
			<FormColumn cols="4">
				<Select required {disabled}
					id="referralSourceOptions"
					label="Where did you hear about our firm?"
					optionList={$lookups.ReferrerOptions}
					bind:value={$model.ReferralSource}
				/>
			</FormColumn>
		</FormRow>

		<h1>Client Details</h1>

		<FormRow>
			<FormColumn cols="4">
				<Select required {disabled}
					id="ClaimantType"
					label="Who does this enquiry relate to?"
					optionList={$lookups.EnquiryTypes}
					bind:value={$model.ClaimantType}
				/>
			</FormColumn>
		</FormRow>

		{#if $model.ClaimantType == "ENQGEN001A02"}
	
		<div style="margin-bottom: 1rem">

			<p>The person you enter in the fields below will be recorded as Shine Lawyers client.</p>

			<FormRow>
				<FormColumn cols="4">
					<button class="btn btn-sm btn-primary" type="button" on:click="{handleSameContactDetails}">Same contact details as Main Contact</button>
				</FormColumn>
			</FormRow>

			<Contact bind:title="{$model.Claimant.Title}"
					 bind:firstName="{$model.Claimant.FirstName}"
					 bind:middleName="{$model.Claimant.MiddleName}"
					 bind:surname="{$model.Claimant.Surname}"
					 bind:dateOfBirth="{$model.Claimant.DateOfBirth}"
					 bind:emailAddress="{$model.Claimant.EmailAddress}"
					 bind:phoneNumber="{$model.Claimant.PhoneNumber}"
					 bind:address="{$model.ClaimantAddress}"
					 idPrefix="claim"
					 required {disabled}></Contact>

		</div>

		{/if}
	
		<FormRow>
			<div class="col-md-8 col-sm-12">
				<Checkbox {disabled} required 
					bind:checked="{$model.PrivacyPolicyConfirmed}" 
					label="I agree to the Shine Lawyers <a href='https://www.shine.com.au/privacy-policy' title='Privacy Policy' target='_blank'>Privacy Policy</a>" 
					id="privacy"></Checkbox>
			</div>
		</FormRow>

		{#if !disabled}
			<FormRow>
				<FormColumn class="last">
					<NavigationButtons bind:buttons={buttons} />
				</FormColumn>
			</FormRow>
		{/if}
	</Form>

</PageSection>
